import useSpotlight from "../../../hooks/useSpotlight";

/**
 * Shared spotlight-enabled glass card wrapper.
 * Translation: Shared spotlight-enabled glass card wrapper.
 *
 * @param {Object} props - Spotlight card props.
 * @returns {JSX.Element} Wrapped spotlight card.
 */
const SpotlightCard = ({ children, className = "", as: Component = "article" }) => {
  const { cardRef, handleMouseMove, handleMouseLeave } = useSpotlight();

  return (
    <Component
      ref={cardRef}
      className={`spotlight-card ${className}`.trim()}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="spotlight-overlay">
        <div className="spotlight-gradient" />
      </div>
      <div className="spotlight-card__content">{children}</div>
    </Component>
  );
};

export default SpotlightCard;
